var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "pt-1",
      class: _vm.$vuetify.breakpoint.xs ? "px-2" : "px-1",
    },
    [
      _c(
        "v-card",
        {
          staticClass: "elevation-4 soli-round flex",
          staticStyle: { display: "flex", overflow: "hidden" },
        },
        [
          _c(
            "v-list-item-avatar",
            {
              staticClass: "-blue",
              class: _vm.$vuetify.breakpoint.xs ? "ml-3 mr-0" : "ml-5 mr-1",
              attrs: { size: _vm.$vuetify.breakpoint.xs ? 74 : 88 },
            },
            [_c("v-img", { attrs: { src: "/grandview-exterior.webp" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-col align-self-center" },
            [
              _c(
                "v-card-title",
                { staticClass: "pb-0 text-subtitle-1 text-sm-h6" },
                [
                  _vm._v(
                    _vm._s(
                      `Welcome${
                        _vm.welcomeBack ? " Back" : _vm.nothingBooked ? "!" : ""
                      }, ${_vm.user.first_name}!`
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.getTotalPasses
                ? _c("v-card-subtitle", { staticClass: "pb-0 pt-3" }, [
                    _vm._v(
                      _vm._s(
                        `You have ${_vm.getTotalPasses} Drop-In passes left`
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "px-3 py-2 flex",
                  class: _vm.$vuetify.breakpoint.xs ? "flex-col" : null,
                },
                [
                  _vm.getTotalPasses
                    ? _c(
                        "SoliBtn",
                        {
                          staticClass: "ma-1",
                          attrs: {
                            small: _vm.$vuetify.breakpoint.width < 375,
                            disabled: _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("bookNow", {
                                type: {
                                  dropIn: true,
                                  name: "Drop-In",
                                  originalType: "Drop-In",
                                  disabled: false,
                                  recurring: false,
                                },
                              })
                            },
                          },
                        },
                        [_vm._v("Book a Drop-In")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "SoliBtn",
                    {
                      staticClass: "ma-1",
                      attrs: {
                        small: _vm.$vuetify.breakpoint.width < 400,
                        disabled: _vm.disabled,
                        loading: _vm.apiLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("bookNow", {
                            type: {
                              name: "Reschedule",
                              originalType: "Weekly Lesson",
                              recurring: false,
                              disabled: false,
                              reschedule: true,
                            },
                          })
                        },
                      },
                    },
                    [_vm._v("Reschedule A Missed Lesson\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.nothingBooked
                ? _c("v-col", { staticClass: "px-4" }, [
                    _vm._v(
                      "\n                It looks like you have a pass or membership (awesome!), but\n                you have not been added to the calendar. Contact your\n                studio, teacher, or try again shortly!\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass:
                    "px-4 mb-3 soli-round text-capitalize text-caption text-sm-subtitle-2",
                  attrs: { plain: "", small: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("contactStudio")
                    },
                  },
                },
                [_vm._v("Need help? Contact your studio")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }